import { useCallback, useEffect, useState } from "react";

const PHONE_ENROLL_WAIT_TIME = 30000; // milliseconds;

const usePhoneEnrollStateManager = () => {
  const [phoneInput, setPhoneInput] = useState("");
  const [submittedPhoneNumber, setSubmittedPhoneNumber] = useState("");
  const [isEnrollmentDisabled, setIsEnrollmentDisabled] = useState(false);
  const [phoneEnrollWaitTimer, setPhoneEnrollWaitTimer] = useState<
    number | null
  >(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    // Okta API does not allow the same phone number to be enrolled within 30 seconds of each other.
    // Adding UI logic to disable the enroll button during this wait time or until the user enters a different phone number.
    setIsEnrollmentDisabled(
      // Empty input
      !phoneInput ||
        // Enrollment delay timer is still active
        (!!phoneEnrollWaitTimer &&
          // Current phone number in input matches the previously submitted phone number
          !!submittedPhoneNumber &&
          phoneInput === submittedPhoneNumber),
    );
  }, [phoneInput, submittedPhoneNumber, phoneEnrollWaitTimer]);

  const _setPhoneInput = useCallback(
    (phoneInput: string) => {
      setErrorMessage("");
      setPhoneInput(phoneInput);
    },
    [setPhoneInput],
  );

  const _setSubmittedPhoneNumber = useCallback(
    (phoneNumber: string) => {
      if (!phoneNumber) return;
      if (phoneEnrollWaitTimer) {
        window.clearTimeout(phoneEnrollWaitTimer);
      }

      const timeout = window.setTimeout(() => {
        setPhoneEnrollWaitTimer(null);
      }, PHONE_ENROLL_WAIT_TIME);

      setPhoneEnrollWaitTimer(timeout);
      setSubmittedPhoneNumber(phoneNumber);
    },
    [phoneEnrollWaitTimer, setSubmittedPhoneNumber],
  );

  return {
    phoneInput,
    setPhoneInput: _setPhoneInput,
    setSubmittedPhoneNumber: _setSubmittedPhoneNumber,
    isEnrollmentDisabled,
    errorMessage,
    setErrorMessage,
  };
};

export default usePhoneEnrollStateManager;
